import React from "react";

export interface BadgeProps {
  children: React.ReactNode;
  variant?: "default" | "accent" | "success" | "danger";
  className?: string;
  title?: string;
}

/**
 * Badge / CellTag -- Editorial Grid
 *
 * Small mono-font label used inside feature cells.
 * Sage background with muted text.
 */
export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = "default",
  className = "",
  title,
}) => {
  // 123kjkdhjth: success/danger backgrounds were bg-[rgba(...)] arbitrary
  // Tailwind values — literal near-copies of design.css's
  // --eg-success-bg/--eg-danger-bg (0.07 alpha here vs. the token's 0.08 —
  // already drifted once). text-eg-* classes stay as-is (they already
  // reference tokens); only the background moves to inline style.
  const variantTextClass: Record<string, string> = {
    default: "text-eg-text-muted bg-eg-bg",
    accent: "text-eg-accent bg-eg-accent-soft",
    success: "text-eg-success",
    danger: "text-eg-danger",
  };
  const variantBg: Record<string, string | undefined> = {
    success: "var(--eg-success-bg)",
    danger: "var(--eg-danger-bg)",
  };

  return (
    <span
      className={`inline-block font-mono text-eg-2xs px-2.5 py-1 rounded-eg-sm ${variantTextClass[variant]} ${className}`}
      style={
        variantBg[variant] ? { background: variantBg[variant] } : undefined
      }
      title={title}
    >
      {children}
    </span>
  );
};
